import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Equal from 'equal-vue'
import 'equal-vue/dist/style.css'
import VueGoogleMaps from '@fawmi/vue-google-maps'
createApp(App).use(Equal).use(VueGoogleMaps, { load: { key: 'AIzaSyAEPYxjyK64PFxLA9V55M3paCNYavTCC-s' } }).use(store).use(router).mount('#app')
